import React from 'react';
interface KPICardProps {
  label: string;
  value: string | number;
  onClick?: () => void;
  active?: boolean;
}
export function KPICard({
  label,
  value,
  onClick,
  active
}: KPICardProps) {
  return <div onClick={onClick} className={`
        bg-white rounded-lg border p-6 transition-all duration-200
        ${onClick ? 'cursor-pointer hover:shadow-md hover:border-blue-300' : ''}
        ${active ? 'ring-2 ring-blue-500 border-blue-500' : 'border-gray-200 shadow-sm'}
      `} data-id="element-385">
      <dt className="text-sm font-medium text-gray-500 truncate mb-1" data-id="element-386">
        {label}
      </dt>
      <dd className="text-3xl font-bold text-gray-900 tracking-tight" data-id="element-387">
        {value}
      </dd>
    </div>;
}